(function(){
  'use strict';

  AOS.init({
    once: true,
    duration: 900,
    offset: 120
  });

})();
//Add linebreak to prod name on desktop

document.addEventListener("DOMContentLoaded", function () {
  // Define the target words
  const targetWords = ["BANKLET®", "Banklet®"];

  // Select all elements with the class .grid-product__title inside .template-collection
  const titles = document.querySelectorAll(".template-collection .grid-product__title");

  titles.forEach((title) => {
      // Check if the element contains any of the target words
      targetWords.forEach((word) => {
          if (title.textContent.includes(word)) {
              // Replace the target word with itself followed by a <br> tag
              const regex = new RegExp(`(${word})`, "g");
              title.innerHTML = title.innerHTML.replace(
                  regex,
                  `$1<br class="desktop-only" />`
              );
          }
      });
  });
});
